import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { orderPoStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderPo";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

orderPoStyles.wrapper = mergeToNew(orderPoStyles.wrapper, {
    width: [12, 12, 12, 12, 12],
    css: css`
        display: flex;
        flex-direction: column;
        padding: 0px;
    `,
});
orderPoStyles.titleText = mergeToNew(orderPoStyles.titleText, {
    variant: "h3",
    css: css`
        margin-bottom: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 16px;
        width: 100%;
    `,
});
orderPoStyles.orderPo = mergeToNew(orderPoStyles.orderPo, {
    css: css`
        padding: 4px;
    `,
});
